// extracted by mini-css-extract-plugin
export default {"periodDiv":"Timer_periodDiv__mp2HO","daopage":"Timer_daopage__cfuyD","fade-in":"Timer_fade-in__UqANz"};